import { createListenerMiddleware } from '@reduxjs/toolkit';

import { RootStateType } from '@/features/store';

import { comparisonSelectors, comparisonSlice } from '../reducer';

const listenerMiddleware = createListenerMiddleware();

/**
 * Слушатель, срабатывающий на удаление элементов сравнения,
 * сбрасывает выбранные для сравнения элементы
 */
listenerMiddleware.startListening({
  actionCreator: comparisonSlice.actions.removeAllItems,
  effect: (action, listenerApi) => {
    listenerApi.dispatch(comparisonSlice.actions.setSelected([]));
  },
});

/**
 * Слушатель, срабатывающий на удаление элемента сравнения,
 * сбрасывает выбранный элемент, если он был удален
 */
listenerMiddleware.startListening({
  actionCreator: comparisonSlice.actions.removeItem,
  effect: (action, listenerApi) => {
    const state = listenerApi.getState() as RootStateType;

    const { selected } = state.comparison;
    const newSelected = selected.filter(id => id !== action.payload);

    if (selected.length !== newSelected.length) {
      listenerApi.dispatch(comparisonSlice.actions.setSelected(newSelected));
    }
  },
});

/**
 * Слушатель, срабатывающий на актуализацию элементов сравнения,
 * сбрасывает выбранные элементы, если они неактуальны
 */
listenerMiddleware.startListening({
  actionCreator: comparisonSlice.actions.actualizeItems,
  effect: (action, listenerApi) => {
    const state = listenerApi.getState() as RootStateType;
    const ids = comparisonSelectors.selectIds(state.comparison);

    const { selected } = state.comparison;
    const newSelected = selected.filter(id => ids.includes(id));

    if (selected.length !== newSelected.length) {
      listenerApi.dispatch(comparisonSlice.actions.setSelected(newSelected));
    }
  },
});

export default listenerMiddleware.middleware;
